export const PageType = Object.freeze({
  ABOUT_US: "about-us",
  TERMS_AND_CONDITIONS: "terms-and-conditions",
  PRIVACY_POLICY: "privacy-policy",
});

export const userPageType = Object.freeze({
  VIEW: "VIEW",
  UPDATE: "UPDATE",
});

export const USER_TYPE = Object.freeze({
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SELECTSTATUS: "Select Status",
});

export const PLATFORM_TYPE = Object.freeze({
  ICO: "ico",
  MAIN_WEBSITE: "main_website",
});

export const PAGE_TYPE = Object.freeze({
  ABOUT_US: "about_us",
  TERMS_CONDITIONS: "terms_conditions",
  PRIVACY_POLICY: "privacy_policy",
});

export const CMS_WEBSITE_TYPE = Object.freeze({
  ICO: "ico",
  TRAVEL: "travel",
});